import { type GridColDef, EllipsisText, Chip } from '@shared/components';

import { DifficultyLevel } from '../../components';

export interface PUseListItem {
  id: string;
  pStat: number;
  pStatPreview: string;
  selected: boolean | null;
  difficulty: DifficultyLevel;
  numberOfExaminee: number;
  calculatedDate: string;
  startedDate: string;
  updatedBy: string;
}

const DIFFICULTY_COLORS: Record<DifficultyLevel, string> = {
  [DifficultyLevel.EASY]: 'success.light',
  [DifficultyLevel.MEDIUM]: 'warning.light',
  [DifficultyLevel.HARD]: 'error.light',
};

const DIFFICULTY_LABELS: Record<DifficultyLevel, string> = {
  [DifficultyLevel.EASY]: 'ง่าย',
  [DifficultyLevel.MEDIUM]: 'กลาง',
  [DifficultyLevel.HARD]: 'ยาก',
};

export const columns: GridColDef<PUseListItem>[] = [
  {
    field: 'pStat',
    headerName: 'ค่า P',
    sortable: false,
    width: 80,
    renderCell: (params) => <EllipsisText>{params.row.pStatPreview}</EllipsisText>,
  },
  {
    field: 'difficulty',
    sortable: false,

    headerName: 'ระดับความยาก',
    minWidth: 124,
    renderCell: (params) => (
      <Chip
        label={DIFFICULTY_LABELS[params.value as DifficultyLevel]}
        size='small'
        sx={{
          color: (theme) => theme.palette.text.primary,
          backgroundColor: DIFFICULTY_COLORS[params.value as DifficultyLevel],

          fontWeight: 600,
        }}
      />
    ),
  },
  {
    field: 'numberOfExaminee',
    sortable: false,

    headerName: 'จำนวนผู้สอบ (คน)',
    minWidth: 145,
    renderCell: (params) => <EllipsisText>{params.value}</EllipsisText>,
  },
  {
    field: 'calculatedDate',
    sortable: false,

    headerName: 'วันที่คำนวณ',
    width: 140,
    renderCell: (params) => <EllipsisText>{params.value}</EllipsisText>,
  },
  {
    field: 'startedDate',
    headerName: 'วันที่เริ่มใช้งาน',
    sortable: false,

    width: 140,
    renderCell: (params) => <EllipsisText>{params.value}</EllipsisText>,
  },
  {
    field: 'updatedBy',
    headerName: 'ผู้บันทึกจากรายงาน',
    sortable: false,

    minWidth: 235,
    renderCell: (params) => <EllipsisText>{params.value}</EllipsisText>,
  },
];
